<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-85">
            <h1 class="md-display-1">Список магазинов</h1>
        </div>
        <div class="md-layout-item md-size-10">
            <md-button class="ct-green" v-on:click="addShop">Добавить магазин</md-button>
        </div>

        <ShopFilter v-on:changeFilter="changeFilter"></ShopFilter>
        <ShopTable :key="keyTable" v-on:editShop="editShop"></ShopTable>
        <EditDialog
        :key="keyDialog+'EditDialog'"
        :openDialog="openDialog"
        @closeDialog="closeDialog()"
        @closeDialogSuccess="closeDialog(true)"
        ></EditDialog>
        <DialogCreateShop
        :key="keyDialogCreate+'dialogCreateShop'"
        :openCreateDialog="openCreateDialog"
        @closeCreateDialog="closeCreateDialog()"
        @closeCreateDialogSuccess="closeCreateDialog(true)"
        ></DialogCreateShop>
    </div>
</template>

<script>

import Vuex from 'vuex'
import ShopFilter from './ShopFilter'
import ShopTable from './ShopTable'

import EditDialog from './ShopEdit'
import DialogCreateShop from './ShopCreate'

import store from '@/store'

const shopFilter = new Vuex.Store({
  state: {
    filtersShop: {
      country_code: store.getters.regionUser
    },
    search: '',
    pagination: {
      current_page: 0,
      count_page: 0
    },
    editId: null
  },
  mutations: {
    setFilter (obj, result) {
      if (result['value'] === 'deleteFilter') {
        this.state.filtersShop[result['name']] = null
      } else {
        this.state.filtersShop[result['name']] = result['value']
      }
    },
    resetPagination () {
      this.state.pagination = {
        current_page: 0,
        count_page: 0
      }
    }
  }
})

export default {
  data () {
    return {
      showTable: 1,
      filter: {},
      keyTable: 1,
      keyDialog: 1,
      openDialog: 0,
      keyDialogCreate: 1,
      openCreateDialog: 0
    }
  },
  name: 'index',
  components: { ShopTable, DialogCreateShop, ShopFilter, EditDialog },
  store: shopFilter,
  methods: {
    changeFilter () {
      this.$store.commit('resetPagination')
      this.keyTable++
    },
    addShop () {
      this.keyDialogCreate++
      this.openCreateDialog = 1
      this.$store.state.createDialog = 1
    },
    editShop () {
      this.keyDialog++
      this.openDialog = 1
    },
    closeDialog (flag) {
      this.openDialog = 0
      this.$store.state.editId = null
      if (flag === true) {
        this.keyTable++
      }
    },
    closeCreateDialog (flag) {
      this.openCreateDialog = 0
      this.$store.state.createDialog = 0
      if (flag === true) {
        this.keyTable++
      }
    }
  }
}
</script>

<style scoped>
    .ct-green {
        background-color: green !important;
        text-align: right;
    }

</style>



// WEBPACK FOOTER //
// src/components/shops/ShopIndex.vue